import { Layout, Typography } from 'antd';
import React from 'react';

export function Footer() {

    return (
        <Layout.Footer style={{ textAlign: 'center' }}>
            <Typography.Text type='secondary'>🚀 Crypto Space Prison © 2022</Typography.Text>
        </Layout.Footer>
    )

}